import { useContext } from "react";
import globalContext from "./context";

const useGlobalContex = () => {
	const context = useContext(globalContext);
	return context;
};

export default useGlobalContex;
